'use client';

import React, { useId } from 'react';
import { composeTailwindRenderProps } from '@utils';
import {
	TextField as AriaTextField,
	TextFieldProps as AriaTextFieldProps,
} from 'react-aria-components';

import { Search } from '../icons';
import { Button } from './Button';
import { FieldGroup, Input } from './Field';

interface SearchFieldProps extends AriaTextFieldProps {
	placeholder?: string;
	theme?: 'light' | 'dark';
	isPending?: boolean;
	onSubmit?: () => void;
}

export function SearchField({
	placeholder,
	theme,
	isPending,
	onSubmit,
	...props
}: SearchFieldProps) {
	const id = useId();

	return (
		<div className="relative flex">
			<AriaTextField
				id={id}
				className={composeTailwindRenderProps(props.className, 'flex-auto')}
				{...props}
			>
				<FieldGroup
					theme={theme}
					isDisabled={props.isDisabled}
					className="flex border-r-0 pr-[62px]"
					onKeyDown={e => {
						if (e.key === 'Enter' && !isPending) {
							onSubmit?.();
						}
					}}
				>
					<Input placeholder={placeholder} theme={theme} autoComplete="off" />
				</FieldGroup>
			</AriaTextField>
			<Button
				onPress={onSubmit}
				isPending={isPending}
				className="absolute right-0 z-10 rounded-l-none px-3! focus:rounded-xs"
				aria-label="Search"
			>
				<Search className="size-icon-md" />
			</Button>
		</div>
	);
}
